module.exports = __webpack_public_path__ + "static/media/p2.e528db3f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/personalization/images/urbanhipster/p2.jpg
// module id = 2936
// module chunks = 0